import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import WebMercatorViewport from 'viewport-mercator-project';
export default class Viewport {
  constructor() {
    _defineProperty(this, "viewport", new WebMercatorViewport());
  }
  syncWithMapCamera(mapCamera) {
    const {
      center,
      zoom,
      pitch,
      bearing,
      viewportHeight,
      viewportWidth
    } = mapCamera;
    const preView = {
      width: this.viewport.width,
      height: this.viewport.height,
      longitude: this.viewport.center[0],
      latitude: this.viewport.center[1],
      zoom: this.viewport.zoom,
      pitch: this.viewport.pitch,
      bearing: this.viewport.bearing
    };
    this.viewport = new WebMercatorViewport(_objectSpread(_objectSpread({}, preView), {}, {
      width: viewportWidth,
      height: viewportHeight,
      longitude: center && center[0],
      latitude: center && center[1],
      zoom,
      pitch,
      bearing
    }));
  }
  getZoom() {
    return this.viewport.zoom;
  }
  getZoomScale() {
    return Math.pow(2, this.getZoom());
  }
  getCenter() {
    return [this.viewport.longitude, this.viewport.latitude];
  }
  getProjectionMatrix() {
    return this.viewport.projectionMatrix;
  }
  getModelMatrix() {
    return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
  }
  getViewMatrix() {
    return this.viewport.viewMatrix;
  }
  getViewMatrixUncentered() {
    // @ts-ignore
    return this.viewport.viewMatrixUncentered;
  }
  getViewProjectionMatrix() {
    // @ts-ignore
    return this.viewport.viewProjectionMatrix;
  }
  getViewProjectionMatrixUncentered() {
    // @ts-ignore
    return this.viewport.viewProjectionMatrix;
  }
  getFocalDistance() {
    return 1;
  }
  projectFlat(lngLat, scale) {
    return this.viewport.projectFlat(lngLat, scale);
  }
}